import React from "react";
import {
  RelatorioNotasDaTurmaGrupoResponse,
  RelatorioNotasDaTurmaNotaResponse,
} from "../../../api/relatorios";
import "./ResumoGrupos.css";

export function ResumoGrupos(props: {
  model?: RelatorioNotasDaTurmaNotaResponse;
}) {
  const model = props.model;
  if (model === undefined) return <></>;
  const mapa: Record<string, RelatorioNotasDaTurmaGrupoResponse[]> = {};
  for (const g of model.grupos) {
    (mapa[g.pageIndex.toString()] ??= []).push(g);
  }
  const pages = Object.entries(mapa);
  pages.sort((a, b) => a[0].localeCompare(b[0]));
  return (
    <>
      {pages.map((p) => {
        const groups = p[1];
        groups.sort((a, b) => a.groupIndex - b.groupIndex);
        return (
          <div key={p[0]} className="relatorioPageNotaDoAluno">
            {groups.map((g) => (
              <div key={g.groupIndex}>
                <div
                  className={
                    (g.completed
                      ? "relatorioGrupoOnNotaDoAluno"
                      : "relatorioGrupoOffNotaDoAluno") +
                    (g.reviewed ? " relatorioGrupoRevisadoNotaDoAluno" : "")
                  }
                />
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
}
